import { CustomerForgotPasswordPage } from '@/pages/customer-portal/auth/CustomerForgotPasswordPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customer/forgot-password')({
	component: CustomerForgotPasswordPage,
});
